module.exports = __webpack_public_path__ + "static/img/img_login_bg_01.3e6259a7.jpg";